import { Component } from '@angular/core'
import { DialogService } from '../../../../../services'
import { NomadeDeactivatorDialogComponent } from './nomade-deactivator-dialog/nomade-deactivator-dialog.component'

@Component({
	selector: 'atyl-nomade-deactivator',
	templateUrl: './nomade-deactivator.component.html',
	styleUrls: ['./nomade-deactivator.component.scss']
})
export class NomadeDeactivatorComponent {
	constructor(
		private dialogService: DialogService
	) {
	}
	openDeactivatorDialog(event: MouseEvent) {
		this.dialogService.open(NomadeDeactivatorDialogComponent, {
			width: '50vw',
			height: '30vh',
			draggable: true,
			minimizable: true,
			resizable: true,
		})
	}
}
